import { render, staticRenderFns } from "./Supervision.vue?vue&type=template&id=37cc5029"
import script from "./Supervision.vue?vue&type=script&lang=js"
export * from "./Supervision.vue?vue&type=script&lang=js"
import style0 from "./Supervision.vue?vue&type=style&index=0&id=37cc5029&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports